(function ($) {
    var sanlo_waypoints = sanlo_waypoints || {};

    sanlo_waypoints.rangeSelector = function () {
        $('.yacht-range').each(function () {
            $(this).find(".yacht-range__slide-navigation").first().waypoint({
                handler: function (direction) {
                    if (direction == 'down') {
                        $(this.element).parents('.yacht-range').find('.yacht-range__slide-navigation').addClass("animate-in");
                    }
                    else {
                        $(this.element).parents('.yacht-range').find('.yacht-range__slide-navigation').removeClass("animate-in");
                    }
                },
                offset: '50%'
            });
        });
    }

    sanlo_waypoints.pageNavigation = function () {
        if (!$('.page-navigation').length) {
            return false;
        }

        $('.page-navigation-spacer').css('height', '0px');
        $('.page-navigation-spacer').waypoint({
            handler: function (direction) {



                if (direction == 'down') {
                    $('.page-navigation-spacer').css('height', $('.page-navigation').height() + 'px');
                    $('.page-navigation').addClass('stick').css('top', 0);
                }
                else {
                    $('.page-navigation').removeClass('stick').css('top', '');
                    $('.page-navigation-spacer').css('height', '0px');
                }
            },
            offset: 0
        })
    }

    sanlo_waypoints.eventsSlider = function () {
        if ($(".events-slider").length) {
            let triggerPoint = 0;
            let progress = 0;

            let waypoint = $(".events-slider").waypoint({
                handler: function () {

                },
                offset: '50%'
            });

            triggerPoint = waypoint[0].triggerPoint;

            $(window).on("scroll", function () {
                initAnimation();
            });

            initAnimation();


            function initAnimation() {
                progress = $(window).scrollTop() - triggerPoint;

                let margin = 0 + (progress * 0.1);

                if (progress > 0 && margin < 20) {
                    $(".events-slider").css('margin-left', margin);
                    $(".events-slider").css('margin-right', margin);
                }
            }
        }
    }

    sanlo_waypoints.priceComments = function () {
        if ($('.boat-item__price-comments').length) {
            $('.boat-item__price-comments').waypoint({
                handler: function (direction) {
                    if (direction == 'down') {
                        $('#' + this.element.id).addClass('show');
                    }
                    else {
                        $('#' + this.element.id).removeClass('show');
                    }
                },
                offset: '40%'
            })
        }
    }

    // control new boat video playback on scroll
    sanlo_waypoints.videoScrollPlay = function () {

        function postMessageToPlayer(player, command) {
            if (player == null || command == null) return;
            player.contentWindow.postMessage(JSON.stringify(command), "*");
        }

        // new boat        
        if ($('.single-new-boat #video').length) {
            new Waypoint.Inview({
                element: $('.single-new-boat #video'),
                enter: function (direction) {
                    var current = $('.single-new-boat #video').find('.image-container--16-9');
                    var player = current[0].querySelector('iframe');
                    if (player !== null) {                        
                        if (current.hasClass('video-youtube')) {
                            postMessageToPlayer(player, {
                                "event": "command",
                                "func": "mute"
                            });
                            postMessageToPlayer(player, {
                                "event": "command",
                                "func": "playVideo"
                            });
                        }
                        if (current.hasClass('video-vimeo')) {
                            postMessageToPlayer(player, {
                                "method": "play"
                            }); 
                        }
                    }
                },
                exited: function (direction) {
                    var current = $('.single-new-boat #video').find('.image-container--16-9');
                    var player = current[0].querySelector('iframe');

                    if (player !== null) {
                        if (current.hasClass('video-youtube')) {
                            postMessageToPlayer(player, {
                                "event": "command",
                                "func": "pauseVideo"
                            });
                        }
                        if (current.hasClass('video-vimeo')) {
                            postMessageToPlayer(player, {
                                "method": "pause"
                            });
                        }
                    }
                } 
            });
        }

        // brokerage boat
        if ($('.single-boat .video-carousel').length) {
            new Waypoint.Inview({
                element: $('.single-boat #boat-video .video-carousel'),
                enter: function (direction) {
                    var current = $('.single-boat .video-carousel').find(' .slick-slide.slick-current');
                    var player = current[0].querySelector('iframe');
                    if (player !== null) {                        
                        if (current.hasClass('video-youtube')) {
                            postMessageToPlayer(player, {
                                "event": "command",
                                "func": "mute"
                            });
                            postMessageToPlayer(player, {
                                "event": "command",
                                "func": "playVideo"
                            });
                        }
                        if (current.hasClass('video-vimeo')) {
                            postMessageToPlayer(player, {
                                "method": "play"
                            });
                        }
                    }
                },
                exited: function (direction) {
                    var current = $('.single-boat .video-carousel').find(' .slick-slide.slick-current');
                    var player = current[0].querySelector('iframe');
                    if (player !== null) {
                        if (current.hasClass('video-youtube')) {
                            postMessageToPlayer(player, {
                                "event": "command",
                                "func": "pauseVideo"
                            });
                        }
                        if (current.hasClass('video-vimeo')) {
                            postMessageToPlayer(player, {
                                "method": "pause"
                            });
                        }
                    }

                }
            });
        }
    }



    $(window).on("load resize", function (e) {
        sanlo_waypoints.rangeSelector();
        sanlo_waypoints.pageNavigation();
        sanlo_waypoints.eventsSlider();
        sanlo_waypoints.priceComments();
        sanlo_waypoints.videoScrollPlay();

        $(document).on('facetwp-refresh facetwp-loaded', function () {
            sanlo_waypoints.priceComments();
        });
    });

})(jQuery); 